import React from 'react';
import { propOr, prop } from 'ramda';
import { Alert, Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Section } from '../components';
import useReview from '../hooks/useReview';
import withUser from '../withUser';
import ReviewButtons from './ReviewButtons';

const Review = ({
  item,
  version,
  reviewComments,
  userCanValidate,
  reFetch
}) => {
  const {
    loading,
    comments,
    updateState,
    isValid,
    updateComments,
    isReview,
    isDraft,
    reviewIsRejected
  } = useReview(version, reviewComments, item, reFetch);

  if (!isReview && (!reviewIsRejected || !isDraft)) {
    return null;
  }

  if (reviewIsRejected && isDraft) {
    return (
      <Alert
        type="warning"
        showIcon
        closable
        description={(
          <div>
            La publication de cette offre a été rejetée pour les raisons suivantes :
            <br />
            <br />
            <span className="font-bold">{propOr('', 'rejectionReason', reviewComments)}</span>
          </div>
        )}
      />
    );
  }

  return (
    <Section title="ma revue">
      {userCanValidate && (
        <div className="flex justify-end gap-3 absolute top-6 right-8">
          <ReviewButtons item={item} reFetch={reFetch} />
        </div>
      )}

      <label className="mb-2 block">Commentaire de revue</label>
      <TextArea
        rows={3}
        value={comments}
        onChange={e => updateState('comments', e.target.value)}
        className="w-full p-2"
        placeholder="Commentaires..."
      />

      <Button
        loading={loading.updateComment}
        className="block mt-4"
        disabled={!isValid}
        onClick={updateComments}
      >
        Mettre à jour les commentaires
      </Button>
    </Section>
  );
};

const ReviewWrapper = ({ item, userCanValidate, reFetch }) => {
  if (!item) {
    return null;
  }

  const version = prop('version', item);
  const reviewComments = propOr({}, 'reviewComments', version);

  return (
    <Review
      item={item}
      reFetch={reFetch}
      version={version}
      reviewComments={reviewComments}
      userCanValidate={userCanValidate}
    />
  );
};

export default withUser(ReviewWrapper);
